module.exports = __webpack_public_path__ + "static/media/portrait-01.2a7091fd.jpg";